import { LegalPageLayout } from "@/src/legal/components/legal-page-layout";

export function LegalNoticesPage() {
	return <LegalPageLayout documentKey="legal_notices" layout="cards" />;
}
